export const REQUEST_ADD_USER_ADDRESS_FINISHED  = "REQUEST_ADD_USER_ADDRESS_FINISHED"
export const REQUEST_ADD_USER_ADDRESS  = "REQUEST_ADD_USER_ADDRESS"
export const PRE_ADD_USER_ADDRESS = "PRE_ADD_DELIVERY_ADDRESS";
export const ADD_USER_ADDRESS = "ADD_DELIVERY_ADDRESS";

export const REQUEST_UPDATE_USER_DATA_FINISHED = "REQUEST_UPDATE_USER_DATA_FINISHED";
export const REQUEST_UPDATE_USER_DATA = "REQUEST_UPDATE_USER_DATA";
export const PRE_UPDATE_USER_DATA = "PRE_UPDATE_USER_DATA";
export const UPDATE_USER_DATA = "UPDATE_USER_DATA";

export const GET_USER_DATA = "GET_USER_DATA";
export const REQUEST_GET_USER_DATA = "REQUEST_USER_DATA";
export const PRE_GET_USER_DATA = "PRE_GET_USER_DATA";
export const REQUEST_GET_USER_DATA_FINISHED = "REQUEST_USER_DATA_FINISHED"

export const MISSING_FIELDS = "MISSING_FIELDS";
export const CHECK_FORM_USER = "CHECK_FORM_USER";